module.exports = __webpack_public_path__ + "img/退出.0e092e7c.png";